var map = {
	"./cat_1.png": 8023,
	"./cat_3.png": 6805,
	"./cat_5.png": 2899,
	"./cat_7.png": 1121,
	"./cat_9.png": 63,
	"./cat_activity_11.png": 3914,
	"./cat_activity_12.png": 7729,
	"./cat_activity_13.png": 9864,
	"./cat_activity_14.png": 5031,
	"./dog_1.png": 8169,
	"./dog_3.png": 1115,
	"./dog_5.png": 6333,
	"./dog_7.png": 4111,
	"./dog_9.png": 1249,
	"./dog_activity_11.png": 7656,
	"./dog_activity_12.png": 9619,
	"./dog_activity_13.png": 7706,
	"./dog_activity_14.png": 8133,
	"./eating_15.png": 1588,
	"./eating_16.png": 4047,
	"./eating_17.png": 8950,
	"./eating_18.png": 5105,
	"./food_19.png": 1526,
	"./food_20.png": 7830,
	"./food_21.png": 1631,
	"./food_22.png": 6356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4628;